export default __webpack_public_path__ + "static/media/cedrus_kw53.90c35f95.jpg";